import type {FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';

import {ImageBlock} from '@/modules/foundation/components/image/ImageBlock';
import {Heading} from '@/modules/foundation/components/typography/heading';
import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import {formatDate} from '@/modules/foundation/shared/format';

import type {Article} from '../../shared/types';

type Props = {
	article: Article;
	headingLevel: 2 | 3;
};

export const ArticleCard: FC<Props> = ({article, headingLevel}) => {
	const {title, createdAt, href, imageWeb, lead} = article;

	const formattedDate = formatDate(createdAt);

	return (
		<Link href={href} className={clsx('block', 'group')}>
			<Heading
				level={headingLevel}
				size="2xlarge"
				spacing
				className={clsx('font-bold', 'group-hover:underline')}
			>
				{title}
			</Heading>
			{imageWeb && (
				<ImageBlock
					height={imageWeb.image.height}
					src={imageWeb.image.src}
					width={imageWeb.image.width}
					alt={imageWeb.altText ?? ''}
					className={clsx('rounded-3xl', 'mb-3')}
				/>
			)}

			<div className={clsx('grid', 'gap-2')}>
				<time dateTime={createdAt} className="font-bold">
					{formattedDate}
				</time>

				{lead && <Paragraph className="mb-2">{lead}</Paragraph>}

				<span
					aria-hidden
					className={clsx(
						'justify-self-start',
						'bg-white',
						'text-[#014A7F]',
						'group-hover:bg-secondary-dark',
						'group-hover:text-white',
						'group-active:bg-secondary-light',
						'group-active:text-[#014A7F]',
						'border',
						'border-primary-content',
						'no-underline',
						'inline-flex',
						'items-center',
						'justify-center',
						'gap-2',
						'shrink-0',
						'transition-colors',
						'rounded-full',
						'px-5',
						'py-3',
						'text-base',
						'shadow-[0_3px_4px_0px_rgba(0,74,127,0.25)]',
					)}
				>
					Les mer
				</span>
			</div>
		</Link>
	);
};
